import { createFileRoute } from '@tanstack/react-router'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'
import { AttestationSigningPage } from '#/modules/rcda-attestation/front-office/attestation-signing-page/attestation-signing-page.tsx'

export const Route = createFileRoute('/s/attestations/$token')({
  component: AttestationSigningRoute,
})

function AttestationSigningRoute() {
  const { token } = Route.useParams()

  return (
    <PharaohNextScope>
      <AttestationSigningPage token={token} />
    </PharaohNextScope>
  )
}
